export default "__VITE_ASSET__DK0UoCpD__"